<template>
  <div
    v-if="isInterlocutorOnline"
    class="online-status"
  >
    <span class="online-status__title">
      {{ trans('offer.contact.status.online' ) }}
    </span>

    <span class="online-status__icon" />
  </div>
</template>

<script>
import translation from '@elements/translation';
import RealTimeMixin from '@atoms/real-time-mixin';

export default {
  mixins: [ RealTimeMixin, translation ],
  data: () => ({
    takeControlActive: false,
  }),
  computed: {
    interlocutor() {
      return window.initialAppState.interlocutor ?? null;
    },
  },
  mounted() {
    const takeControlBanner = document.getElementsByClassName(
      'banner__container--takecontrol',
    )[0];

    this.takeControlActive = takeControlBanner !== undefined;

    if (!this.takeControlActive) {
      this.getUsersOnline();
    }
  },
};
</script>
